<template>
    <span class="flex"
        ><a :href="link" class="nav-item hover:underline pr-1 self-center"
            ><span class="font-bold">{{ title }}{{ index }}</span></a
        ><span :class="'text-xs self-center ' + changeColor"
            >{{ this.change }}%<span v-html="changeIndicator"></span></span
    ></span>
</template>

<script>
function initialState() {
    return {};
}
import { mapGetters } from "vuex";

export default {
    props: {
        link: {
            type: String,
            required: true,
            default: "",
        },
        type: {
            type: String,
            required: true,
            default: "",
        },
        index: {
            type: Number | String,
            required: true,
            default: 0,
        },
        change: {
            type: Number | String,
            required: true,
            default: 0,
        },
        showTitle: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return initialState();
    },
    mounted() {},
    methods: {},
    watch: {},
    computed: {
        title() {
            if (!this.showTitle) {
                return "";
            } else {
                return this.type == "auction" ? "DSX: " : "DWX: ";
            }
        },
        changeIndicator() {
            return parseFloat(this.change) > 0
                ? '<i class="far fa-long-arrow-alt-up up"></i>'
                : '<i class="far fa-long-arrow-alt-down down"></i>';
        },
        changeColor() {
            return parseFloat(this.change) > 0
                ? "text-emerald-400"
                : "text-red-400";
        },
    },
};
</script>

<style lang="scss" scoped></style>
